import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { SelectField, MenuItem } from 'material-ui';

import '../../../grid.css';
import Btn from '../../../components/Btn';

class ProjectStatus extends Component {
    toggleProjectStatusIsVisible() {
        const { setProjectStatusIsVisible, isVisible } = this.props;
        setProjectStatusIsVisible(!isVisible);
    }

    handleJobStatusChange(value) {
        const { setJobStatus } = this.props;
        setJobStatus(value);
    }

    handleArchiveChange(value) {
        const { setArchiveStatus } = this.props;
        setArchiveStatus(value);
    }

    toggleSoldStatus(value) {
        const { setSoldStatus } = this.props;
        setSoldStatus(value);
    }

    render() {
        const {
            isLocked, isVisible, jobStatus, archiveStatus, soldStatus,
        } = this.props;
        return (
            <div>
                <Btn label="Project Status" onClick={(e, value) => this.toggleProjectStatusIsVisible(value)} />
                {isVisible && (
                    <div className="row">
                        <div className="col span-1-of-3">
                            <SelectField
                                value={jobStatus}
                                onChange={(event, index, value) =>
                                    this.handleJobStatusChange(value)
                                }
                                disabled={isLocked}
                            >
                                <MenuItem value="lead" primaryText="Lead" />
                                <MenuItem value="scheduled" primaryText="Proposal Scheduled" />
                                <MenuItem value="presented" primaryText="Proposal Presented" />
                                <MenuItem value="siteVisitCompleted" primaryText="Site Visit Completed" />
                                <MenuItem value="engineeringCompleted" primaryText="Engineering Completed" />
                                <MenuItem value="installationCompleted" primaryText="Installation Completed" />
                                <MenuItem value="finalInspectionCompleted" primaryText="Final Inspection Completed" />
                                <MenuItem value="ptoGranted" primaryText="PTO Granted" />
                            </SelectField>
                        </div>
                        <div className="col span-1-of-3">
                            <SelectField
                                value={soldStatus}
                                onChange={(event, index, value) =>
                                    this.toggleSoldStatus(value)
                                }
                                disabled={isLocked}
                            >
                                <MenuItem value primaryText="Sold" />
                                <MenuItem value={false} primaryText="Not Sold" />
                            </SelectField>
                        </div>
                        <div className="col span-1-of-3">
                            <SelectField
                                value={archiveStatus}
                                onChange={(event, index, value) =>
                                    this.handleArchiveChange(value)
                                }
                                disabled={isLocked}
                            >
                                <MenuItem value primaryText="Archive" />
                                <MenuItem value={false} primaryText="Do not Archive" />
                            </SelectField>
                        </div>
                    </div>

                )}
            </div>
        );
    }
}

ProjectStatus.propTypes = {
    isVisible: PropTypes.number.isRequired,
    isLocked: PropTypes.bool.isRequired,
    soldStatus: PropTypes.bool.isRequired,
    archiveStatus: PropTypes.bool.isRequired,
    setProjectStatusIsVisible: PropTypes.func.isRequired,
    setArchiveStatus: PropTypes.func.isRequired,
    setSoldStatus: PropTypes.func.isRequired,
    setJobStatus: PropTypes.func.isRequired,
    jobStatus: PropTypes.string.isRequired,
};

export default ProjectStatus;



// WEBPACK FOOTER //
// ./src/containers/Inputs/ProjectStatus/ProjectStatus.js